import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { SidenavService , SidenavService as SidenavMenuService } from './services/sidenav.service';
import { InitializeStore } from '../shared/functions/store.functions';
import { AppState } from './models/app.model';
import { appStateConfig } from '../config/app.config';
import { AuthState, authStateConfig } from './models/auth.model';
import { JWTState, jwtStateConfig } from './models/jwt.model';
import { CookieService } from './services/cookie.service';
import { JwtService } from './services/jwt.service';
import { DialogService } from './services/dialog.service';
import { MatDialogModule } from '@angular/material/dialog';
import { RoutingService } from './services/routing.service';
import { BottomSheetService } from './services/bottom-sheet.service';
import { ScreenService } from './services/screen.service';
import { QueryService } from './services/query.service';
import { QuerySentrynelService } from './services/query-sentrynel.service';
import { SnackbarService } from './services/snackbar.service';
import { RoleState, roleStateConfig } from './models/role.model';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatDialogModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    ...InitializeStore<AppState>('app-store', appStateConfig),
    ...InitializeStore<JWTState>('jwt-store', jwtStateConfig),
    ...InitializeStore<AuthState>('auth-store', authStateConfig),
    ...InitializeStore<RoleState>('role-store', roleStateConfig),
    ScreenService,
    CookieService,
    ApiService,
    QueryService,
    JwtService,
    AuthService,
    SidenavService,
    QuerySentrynelService,
    SidenavMenuService,
    DialogService,
    SnackbarService,
    BottomSheetService,
    RoutingService,
  ],
})
export class CoreModule {}
